export default "__VITE_ASSET__B0Cw6Oyc__"